import { OPERATOR as O } from '../../lib/legal';

const mail = O.email.replace('@', '(at)');

export function Impressum() {
  return (
    <article className="screen legal">
      <div><span className="label">Rechtliches</span><h2>Impressum</h2></div>

      <section>
        <h3>Anbieter</h3>
        <p>{O.name}<br />{O.street}<br />{O.city}<br />{O.country}</p>
      </section>

      <section>
        <h3>Kontakt</h3>
        <p>E-Mail: {mail}</p>
      </section>

      <section>
        <h3>Umsatzsteuer</h3>
        <p>Umsatzsteuer-Identifikationsnummer: {O.vat}</p>
      </section>

      <section>
        <h3>Haftung für Links</h3>
        <p>Dieses Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für diese fremden Inhalte übernehmen wir deshalb keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft; rechtswidrige Inhalte waren nicht erkennbar. Eine dauerhafte inhaltliche Kontrolle der verlinkten Seiten ist ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Werden uns Rechtsverletzungen bekannt, entfernen wir derartige Links umgehend.</p>
      </section>

      <section>
        <h3>Urheberrecht</h3>
        <p>Die von uns erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht der Republik Zypern. Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
        <p>Die Parteien, Personen und Ereignisse im Spiel sind frei erfunden. Ähnlichkeiten mit realen Parteien oder Personen sind nicht beabsichtigt. Die Karte der Bundesländer stammt von <a href="https://mapsvg.com/maps/germany" target="_blank" rel="noopener noreferrer">mapsvg.com</a> (Lizenz CC BY 4.0). Die Schriften Barlow, Barlow Condensed, JetBrains Mono, Source Serif 4 und UnifrakturMaguntia stehen unter der SIL Open Font License und werden von unserem Server ausgeliefert.</p>
      </section>
    </article>
  );
}
